import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  otpInputs: {
    display: 'flex',
    gap: theme.app.spacing.md,
    justifyContent: 'center',
    width: '100%'
  },

  otpInput: {
    width: 56,
    height: 64,
    background: theme.app.colors.input.background,
    border: '2px solid rgba(222, 161, 105, 0.3)',
    borderRadius: theme.app.borderRadius.lg,
    fontFamily: theme.app.typography.fontFamily.main,
    fontSize: theme.app.typography.span.fontSize,
    fontWeight: 600,
    color: theme.app.colors.text.light,
    textAlign: 'center',
    transition: 'all 0.2s',
    outline: 'none',
    '&:focus': {
      borderColor: '#dea169',
      background: theme.app.colors.input.backgroundFocus
    },
    '&:disabled': {
      opacity: 0.5,
      cursor: 'not-allowed'
    }
  }
}))
